import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "redux/actions/knowledgeActions";
import { Translate } from "react-redux-i18n";
import MiniLoader from "components/MiniLoader";

const Body = (props) => {
    const categoryId = props.categoryId ?? 1;

    const onClick = () => {
        props.loadListScroll({
            id: props.user_id,
            index: props.pageCount,
            category_id: categoryId
        }, props.token);
    };

    return (
        <div className="knowledge-main-scroll">
            <div className="knowledge-article">
                {props.list.map((item, index) => (
                    <div
                        key={item.id || index}
                        className="knowledge-article-block"
                        dangerouslySetInnerHTML={{ __html: item.text }}
                    />
                ))}
            </div>
            {props.pageSize === 1 && (
                props.loadingMore ? (
                    <MiniLoader />
                ) : (
                    <div className="knowledge-load-more">
                        <button type="button" className="btn btn-primary" onClick={onClick}>
                            <Translate value="load_more" />
                        </button>
                    </div>
                )
            )}
        </div>
    );
};

Body.propTypes = {
    className: PropTypes.string,
    history: PropTypes.object,
    categoryId: PropTypes.number,
};

function mapStateToProps(reducer) {
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,
        list: reducer.knowledge.list,
        loading: reducer.knowledge.loading,
        error: reducer.knowledge.error,
        pageCount: reducer.knowledge.page_count,
        pageSize: reducer.knowledge.page_size,
        loadingMore: reducer.knowledge.loadingMore,
    };
}

const mapDispatchToProps = dispatch => ({
    loadList: (params, token) =>
        dispatch(actions.loadList({ params, token })),
    loadListScroll: (params, token) =>
        dispatch(actions.loadListScroll({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Body);
